var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNlp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.96001 14.0615H10.2358L13.8634 19.8702H13.7752V14.0615H14.8922V21.5517H13.7046L9.9007 15.4842H10.0771V21.5517H8.96001V14.0615ZM18.3051 14.0615V20.5757H21.5328V21.5517H17.188V14.0615H18.3051ZM22.7853 21.5517V14.0615H25.2958C26.1306 14.0615 26.7734 14.2692 27.2242 14.6847C27.6749 15.1001 27.9003 15.6743 27.9003 16.4073C27.9003 17.1324 27.6749 17.7027 27.2242 18.1182C26.7734 18.5297 26.1306 18.7355 25.2958 18.7355H23.9141V21.5517H22.7853ZM23.9141 17.7595H25.2958C25.774 17.7595 26.1365 17.6361 26.3834 17.3891C26.6304 17.1422 26.7538 16.8149 26.7538 16.4073C26.7538 15.9957 26.6304 15.6626 26.3834 15.4078C26.1365 15.153 25.774 15.0257 25.2958 15.0257H23.9141V17.7595Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 33C26.0604 33 33 26.0604 33 17.5C33 8.93959 26.0604 2 17.5 2C8.93959 2 2 8.93959 2 17.5C2 26.0604 8.93959 33 17.5 33Z",
    stroke: "white",
    strokeWidth: 2.13793,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNlp);
export default __webpack_public_path__ + "static/media/Icon-NLP.ad235425f3bb287218ccd223f9b5d9bb.svg";
export { ForwardRef as ReactComponent };